import React from "react";
import DeviceLinkingMap from "./DeviceLinkingMap";
import { useAppSelector, useAppDispatch } from "./store/hooks";
import { selectCurrentPosition, setCurrentPosition } from "./store/reducers/deviceLinkingAppStoreSlice";
import { LatLong } from "../types";

type ClientAssetDataAndDeviceMapViewProps = {
    className: string;
};

export default function ClientAssetDataAndDeviceMapView(props: ClientAssetDataAndDeviceMapViewProps): JSX.Element {
    const dispatch = useAppDispatch();
    const currentPosition = useAppSelector(selectCurrentPosition);

    return (
        <div className={props.className}>
            {currentPosition ? (
                <DeviceLinkingMap
                    targetPosition={currentPosition ? currentPosition : { latitude: 0, longitude: 0 }}
                    setTargetPosition={(newPosition: LatLong) => {
                        dispatch(setCurrentPosition(newPosition));
                    }}
                    satelliteView={false}
                />
            ) : (
                <div
                    style={{
                        width: "100%",
                        height: "100%",
                        textAlign: "center",
                        border: "1px solid #dddddd",
                        backgroundColor: "#eeeeee",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <b>Map will initialize as soon as an asset is selected</b>
                </div>
            )}
        </div>
    );
}
